export default __webpack_public_path__ + "static/media/III_Old_White.1964db49.png";